type Capture = (error: unknown) => void

export const installGlobalErrorHandlers = (capture: Capture): (() => void) => {
  const onError = (event: ErrorEvent) => {
    if (!event.error) return
    capture(event.error)
  }

  const onRejection = (event: PromiseRejectionEvent) => {
    capture(event.reason ?? "Unhandled promise rejection")
  }

  window.addEventListener("error", onError)
  window.addEventListener("unhandledrejection", onRejection)

  return () => {
    window.removeEventListener("error", onError)
    window.removeEventListener("unhandledrejection", onRejection)
  }
}

export const installFlushOnHidden = (flush: () => void): (() => void) => {
  const onVisibilityChange = () => {
    if (document.visibilityState === "hidden") flush()
  }

  document.addEventListener("visibilitychange", onVisibilityChange)

  return () => {
    document.removeEventListener("visibilitychange", onVisibilityChange)
  }
}
